import {
    mlAuto,
    mrAuto,
    title,
} from "assets/jss/material-kit-pro-react.js";

const FeatureSectionStyle = {
    mlAuto,
    mrAuto,
    title,
    features4: {
        padding: "80px 0",
        "& $phoneContainer": {
            maxWidth: "260px",
            margin: "60px auto 0"
        }
    },
    textCenter: {
        textAlign: "center"
    },
    phoneContainer: {
        "& img": {
            width: "90%"
        }
    },
};

export default FeatureSectionStyle;
